import { createElement } from 'react';
import { SuspenseHandler as RawSuspenseHandler } from 'apps/acp/packages/react-suspense-handler';
import { Container } from './suspense-handler.ccm.css';
export const SuspenseHandler = props => createElement(Container.div, null, createElement(RawSuspenseHandler, props));